import { Injectable } from '@angular/core';

import {
  ActiveState,
  EntityState,
  EntityStore,
  StoreConfig,
} from '@datorama/akita';

import { Billing } from './billing.model';

export interface BillingState
  extends EntityState<Billing, string>,
    ActiveState<string> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'billing', resettable: true })
export class BillingStore extends EntityStore<BillingState> {
  constructor() {
    super();
  }
}
